class ContactLifeCycleController {
  constructor(enums, contactService, $ngConfirm, $scope) {
    "ngInject";
    
    this.enums = enums;
    this.contactService = contactService;
    this.$ngConfirm = $ngConfirm;
    this._$scope = $scope;
  }

  viewCallDetails(contactLifeCycleId)
  {
    this.contactService.getCallLog(contactLifeCycleId)
      .then(response => {
        this._$scope.callLog = response.data;

        this._$scope.exportDialog = this.$ngConfirm({
          title: 'Call Details',
          contentUrl: `templates/contact/callLogViewTemplate`,
          scope: this._$scope,
          columnClass: 'm',
          type: 'dark',
          buttons: {            
            cancel: {
              text: 'Close',
              btnClass: 'btn-default'
            }
          }          
        });   

      });
  }

  tempFilterFn(obj) {
    return obj.contactMethod !== 'InboundCall' && obj.contactMethod !== 'OutboundCall';
  }
}


export default ContactLifeCycleController;



// WEBPACK FOOTER //
// ./client/app/components/contact/contactView/contactLifeCycle/contactLifeCycle.controller.js